var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReleaseService } from './release.service';
import { FlagService } from './flag.service';
var FeaturesModule = (function () {
    function FeaturesModule() {
    }
    FeaturesModule = __decorate([
        NgModule({
            imports: [
                CommonModule
            ],
            declarations: [],
            //exports: [FlagService],
            providers: [ReleaseService, FlagService]
        })
    ], FeaturesModule);
    return FeaturesModule;
}());
export { FeaturesModule };
//# sourceMappingURL=features.module.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/features/features.module.js
// module id = 542
// module chunks = 0